<ng-container *ngIf="dataroomBrowser?.activeNodeChange | async as _activeNode">
  <div fxLayout="row" fxLayoutAlign="start center" *ngIf="asDataroomNode(_activeNode) as activeNode">
    <div fxLayout="row" fxLayoutAlign="start center">
      <button *ngIf="activeNode.id" mat-icon-button (click)="dataroomBrowser?.goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="title">
        {{ activeNode.name || 'INTL_DATAROOM' | translate }}
      </h1>
    </div>
  </div>
</ng-container>
